module.exports = __webpack_public_path__ + "img/34-IQ7.03fdd25.png";